export default __webpack_public_path__ + "static/media/Archived.efc1bbe0.svg";